import { Slider, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { FormControl } from 'react-bootstrap';
import CustomToggleButton from '../../../shared/atoms/CustomToggleButton';
import { actuatorControlPropTypes } from '../../types';
import CustomTooltip from '../../../shared/atoms/CustomTooltip';

const NumericControl = ({ feature, value, mini, handleChange }) => {
  const [tempValue, setTempValue] = useState(value);
  useEffect(() => {
    setTempValue(value);
  }, [value]);
  return (
    <Stack gap={1} alignItems="center" width="100%">
      {feature.presets && !mini && (
        <CustomToggleButton
          value={value}
          handleChange={(_, newVal) => handleChange(feature.property, newVal)}
          options={feature.presets.map(preset => ({
            value: preset.value,
            content: preset.name,
            label: preset.description,
          }))}
        />
      )}
      <Stack
        direction="row"
        width="100%"
        gap={3}
        sx={{
          '& .form-control': {
            width: 'min-content',
          },
        }}
      >
        <CustomTooltip title={mini ? tempValue : ''}>
          <Slider
            id={`numeric-control-slider-${feature.property}`}
            sx={{
              '& .MuiSlider-valueLabel': {
                overflow: 'visible',
              },
              '& .MuiSlider-markLabel': {
                color: 'white',
              },
              "& .MuiSlider-markLabel[data-index='0']": {
                transform: 'translateX(0)',
              },
              "& .MuiSlider-markLabel[data-index='1']": {
                transform: 'translateX(-100%)',
              },
              '& .MuiSlider-thumb::after': {
                width: mini ? 0 : 'unset',
                height: mini ? 0 : 'unset',
              },
            }}
            size={mini ? 'small' : 'medium'}
            value={tempValue ?? feature.value_min}
            min={feature.value_min}
            max={feature.value_max}
            step={feature.value_step ?? 1}
            valueLabelDisplay={mini ? 'off' : 'auto'}
            onChange={(_, val) => setTempValue(val)}
            onChangeCommitted={(_, newVal) =>
              handleChange(feature.property, newVal)
            }
            marks={
              mini
                ? false
                : [
                    {
                      value: feature.value_min,
                      label: `${feature.value_min} ${feature.unit ?? ''}`,
                    },
                    {
                      value: feature.value_max,
                      label: `${feature.value_max} ${feature.unit ?? ''}`,
                    },
                  ]
            }
          />
        </CustomTooltip>
        {!mini && (
          <FormControl
            id={`numeric-control-input-${feature.property}`}
            aria-labelledby={`numeric-control-slider-${feature.property}`}
            type="number"
            value={value ?? feature.value_min}
            onChange={e =>
              handleChange(feature.property, Number(e.target.value))
            }
            min={feature.value_min}
            max={feature.value_max}
            step={feature.value_step ?? 1}
          />
        )}
      </Stack>
    </Stack>
  );
};

NumericControl.propTypes = actuatorControlPropTypes;

export default NumericControl;
